import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { Observable, combineLatest, map, of, startWith } from 'rxjs';
import { App_AsyncLabel, App_FormCreatorJson } from 'src/app/utils/interfaces';

@Pipe({
  name: 'asyncLabelPipe'
})
export class AsyncLabelPipe implements PipeTransform {

  transform(asyncLabel: App_AsyncLabel | undefined, formCreatorJson: App_FormCreatorJson | undefined, form: FormGroup | undefined): Observable<string> | undefined {
    if (asyncLabel === undefined || formCreatorJson === undefined || form === undefined) {
      return undefined;
    }
    const replaces = asyncLabel?.replaces;
    let str = asyncLabel.str
    if (Array.isArray(replaces) && typeof str === `string`) {
      return combineLatest(replaces.map(replaceInfos => {
        const regExp = /^([\w-]+)\|(\w+):(\w+)$/
        const match = replaceInfos.origin.match(regExp);
        const fieldName = match && match[1] || undefined;
        const typeOfDataFetch = match && match[2] || undefined;
        const onProperty = match && match[3] || undefined;
        if (typeof fieldName === `string` && typeof typeOfDataFetch === `string` && typeof onProperty === `string`) {
          const field: AbstractControl | undefined = this.searchControlsWithingFormElem(form, fieldName)
          let fieldInTemplate: any | undefined
          if (Array.isArray(formCreatorJson.steps)) {
            for (const step of formCreatorJson.steps) {
              if (fieldInTemplate !== undefined) {
                break;
              }
              if (Array.isArray(step.blocs)) {
                for (const bloc of step.blocs) {
                  if (fieldInTemplate !== undefined) {
                    break;
                  }
                  if (Array.isArray(bloc.fields)) {
                    for (const field of bloc.fields) {
                      if (field.name === fieldName) {
                        fieldInTemplate = field;
                        break;
                      }                      
                    }
                  }
                }
              }
            }
          }
          if (field instanceof FormControl && fieldInTemplate !== undefined) {
            return field.valueChanges.pipe(
              startWith(field.value),
              map(value => {
                if (typeOfDataFetch === `liste`) {
                  const options = fieldInTemplate['options'];
                  if (Array.isArray(options)) {
                    const matchingValue = options.find(option => option.value !== undefined && option.value === value);
                    if (matchingValue !== undefined) {
                      const propertyForReplacement = matchingValue[onProperty];
                      if (typeof propertyForReplacement === 'number' || typeof propertyForReplacement === 'string') {
                        return {
                          replaceInfos,
                          value: typeof propertyForReplacement === `number` ? propertyForReplacement.toString() : propertyForReplacement
                        }
                      }
                    }
                  }
                }
                return {
                  replaceInfos,
                  value: undefined,
                }
              })
            )
          }
        }
        return of({
          replaceInfos,
          value: undefined,
        });
      }
      )).pipe(
        map(_ => _.reduce((acc, x) => acc.replace(x.replaceInfos.keyReplace, x.value || x.replaceInfos.defaultValue), asyncLabel.str)))
    }
    return of('');
  }


  searchControlsWithingFormElem(formElem: AbstractControl, fieldName: string): AbstractControl | undefined {
    if (formElem instanceof FormGroup || formElem instanceof FormArray) {
      const arr = Object.entries(formElem.controls);
      for (const element of arr) {
        if (element[0] === fieldName) {
          return element[1];
        } else {
          const resultWithin = this.searchControlsWithingFormElem(element[1], fieldName);
          if (resultWithin) {
            return resultWithin;
          }
        }
      }
      return undefined;
    }
    return undefined;
  }

}
